import { createSlice } from "@reduxjs/toolkit";
import { getAdminPaymentsDashboard, cancelSubscription } from "../thunks/paymentThunks";

const initialState = {
  dashboardData: null,
  loading: false,
  error: null,
};

const adminPaymentsSlice = createSlice({
  name: "adminPayments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminPaymentsDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminPaymentsDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardData = action.payload;
      })
      .addCase(getAdminPaymentsDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || { message: "Failed to fetch dashboard data" };
      })
      .addCase(cancelSubscription.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelSubscription.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(cancelSubscription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || { message: "Failed to cancel subscription" };
      });
  },
});

export default adminPaymentsSlice.reducer;
